import { atom } from 'jotai'

export const productionIPDCommittee = atom([])
export const financialOperation = atom([])
